import { helpers } from "vuelidate/lib/validators";

/**
 * 入力チェックの共通処理を定義する
 */
class ValidateWrapper {
  /**
   * メールアドレスチェックを実施する
   * pythonとチェック内容を合わせるため、vuelidate標準のemailではなく、カスタムを利用する
   */
  get email() {
    return helpers.regex("email", /[^@]+@[^@]+\.[^@]+/);
  }

  /**
   * 半角文字チェックを実施する
   */
  get halfCharacter() {
    return helpers.regex("halfCharacter", /^[ -~]+$/);
  }

  /**
   * 半角数字チェックを実施する
   */
    get singleByteNumber() {
      return helpers.regex("singleByteNumber", /^[0-9]+$/);
    }
  /**
   * 正の小数チェックを実施する
   */
  get unsignedDecimalNumber() {
    return helpers.regex("unsignedDecimalNumber", /^([1-9][0-9]*|0)(\.[0-9])?$/);
  }
  /**
   * 小数チェックを実施する(負の数を許可)
   */
  get signedDecimalNumber() {
    return helpers.regex("signedDecimalNumber", /^-?([1-9][0-9]*|0)(\.[0-9])?$/);
  }
  /**
   * 郵便番号チェックを実施する
   */
  get postalCode() {
    return helpers.regex("postalCode", /^[0-9\\-]+$/);
  }

  /**
   * 電話番号チェックを実施する
   */
  get phoneNumber() {
    return helpers.regex("phoneNumber", /^[0-9\\(\\)\\+\\#\\*\\-]+$/);
  }

  /**
   * ひらがなチェックを実施する
   */
  get kana() {
    return helpers.regex("kana", /^[\u3040-\u309Fー]+$/);
  }
}

class Validate {
  constructor() {
    this._validateWrapper = new ValidateWrapper();
  }

  /**
   * オリジナルの検証ルールを取得する
   */
  get rule() {
    return this._validateWrapper;
  }

  /**
   * エラーメッセージを日本語に変換する
   * @param {検証するvuelidateのオブジェクト。$v} target
   * @param {検証するデータ名} name
   * @param {検証対象。文字列、または条件付き文字列} checks
   * @param {データが編集されときだけ検証するのならtrue} dirtyCheck
   * @returns
   */
  buildLocalizedErrorMessage(target, name, checks, dirtyCheck = true) {
    const errors = [];
    // 条件付きで検証する
    const checkKeys = checks
      .map((item) => {
        if (typeof item === "string") {
          return item;
        }
        if (item.condition) {
          return item.value;
        }
        return null;
      })
      .filter((item) => item != null);
    // 検証が不要ならエラーメッセージ無しを返す
    if (dirtyCheck && !target.$dirty) return errors;
    // 必須チェック
    if (checkKeys.includes("required")) {
      !target.required && errors.push(`${name}は必須です`);
    }
    // 最大文字数チェック
    if (checkKeys.includes("maxLength")) {
      !target.maxLength &&
        errors.push(
          `${name}は${target.$params.maxLength.max}文字以下で入力して下さい`
        );
    }
    // メールアドレス形式チェック
    if (checkKeys.includes("email")) {
      !target.email && errors.push(`${name}の形式で入力して下さい`);
    }
    // 電話番号形式チェック
    if (checkKeys.includes("phoneNumber")) {
      !target.phoneNumber && errors.push(`${name}の形式で入力して下さい`);
    }
    // 半角文字チェック
    if (checkKeys.includes("halfCharacter")) {
      !target.halfCharacter &&
        errors.push(`${name}は英数字記号で入力して下さい`);
    }
    // 半角数字チェック
    if (checkKeys.includes("singleByteNumber")) {
      !target.singleByteNumber &&
        errors.push(`${name}は半角数字で入力して下さい`);
    }
    // 正の小数チェック
    if (checkKeys.includes("unsignedDecimalNumber")) {
      !target.unsignedDecimalNumber &&
        errors.push(`${name}は小数第一位までの半角数字で入力して下さい`);
    }
    // 小数チェック
    if (checkKeys.includes("signedDecimalNumber")) {
      !target.signedDecimalNumber &&
        errors.push(`${name}は小数第一位までの半角数字で入力して下さい`);
    }
    // 郵便番号チェック
    if (checkKeys.includes("postalCode")) {
      !target.postalCode && errors.push(`${name}の形式で入力して下さい`);
    }
    // かなチェック
    if (checkKeys.includes("kana")) {
      !target.kana && errors.push(`${name}はひらがなで入力して下さい`);
    }
    return errors;
  }

  /**
   * エラーがあるのならtrueを返す
   * @param {検証するvuelidateのオブジェクト。$v} target
   */
  hasError(targets) {
    if (targets.some((target) => target.$invalid)) {
      return true;
    }
    return false;
  }
}

export default new Validate();
